import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { from, Subscription } from 'rxjs';
import { KironComponent } from '../kiron/kiron.component';
import { } from './virtual.module';
import { RouterModule, Routes, Router, RouterLink, NavigationEnd } from '@angular/router';
import { betCategories } from './virtual-categories'
import { StmgService } from 'src/app/services/state_Management/stmg.service';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-virtual',
  templateUrl: './virtual.component.html',
  styleUrls: ['./virtual.component.scss'],
})
export class VirtualComponent implements OnInit {

  constructor(public router: Router, public renderer: Renderer2, public ele: ElementRef, private stmgService: StmgService,
    public translate: TranslateService,) { }

  trackside: boolean = false;
  next10: boolean = true;
  kiron: boolean = false;
  allrace: boolean = false
  nova: boolean = false
  luckyHorse: boolean = false
  cricketSuperOver: boolean = false
  racingRoulette:boolean = false;
  keno:boolean = false;
  luckyloot:boolean = false;

  selectedBetCategory: any;

  cat: any
  categories_arry;

  isRacing = true;
  isSports = false;
  isGames = false;
  private routerSub: Subscription;

  VRCategories:any

  ngOnInit() {
    
    this.updateCategoryFlags(this.router.url);

    // When refresh hide home page elements
    this.stmgService.setShowHomeElements(false);
    this.stmgService.setInVirtualSection(true);

    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateCategoryFlags(event.urlAfterRedirects);
      });

    //this.cat= new betCategories();
    this.categories_arry = this.categories;
    //console.log(this.categories_arry);
    this.selectedBetCategory = this.categories_arry[0];

    //load new data when main nav bar clicked
    this.stmgService.vrRefresh_status.subscribe(message => {
      //this.cat= new betCategories();
      this.categories_arry = this.categories;
      this.selectedBetCategory = this.categories_arry[0];
      this.next10 = this.isRacing;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = this.isSports;
      this.racingRoulette = this.isGames;
      this.keno = false;
      this.luckyloot = false;
    });

    this.stmgService.language_status.subscribe(message => {
      this.translate.get('VR_CATEGORIES').subscribe((res: string) => {
        this.VRCategories = res;
        let index = 0;
        this.categories.forEach(ele => {
          this.categories[index].name = res[index]
          index++
        })
      });
      this.categories_arry = this.categories;
    });

  }


  gototab(tab, event, item) {
    console.log(this.filteredCategories);

    this.selectedBetCategory = item;
    let myTag = this.ele.nativeElement.querySelectorAll("a");

    myTag.forEach(ele => {
      ele.classList.remove('active');
    })

    //set secondary nav bar active color
    if (event.target.id == "aTag") {
      this.renderer.addClass(event.target, 'active');
    } else {
      this.renderer.addClass(event.target.parentNode, 'active');
    }


    if (tab == 1) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = false;
      this.allrace = true;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = false;
      this.stmgService.nav2AllRaceRefresh(true);
    }
    if (tab == 2) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = true;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = false;
      this.stmgService.nav2tracksideRefresh(true)
    }
    if (tab == 3) {
      this.next10 = false;
      this.kiron = true;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = false;
    }
    if (tab == 4) {
      this.next10 = true;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = false;
      this.stmgService.nav2Next10Refresh(true);
    }
    if (tab == 5) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = true;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = false;
    }
    if (tab == 6) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = true;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = false;
    }
    if (tab == 7) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = true;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = false;
    }
    if (tab == 8) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = true;
      this.keno = false;
      this.luckyloot = false;
    }
    if (tab == 9) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = true;
      this.luckyloot = false;
    }
    if (tab == 10) {
      this.next10 = false;
      this.kiron = false;
      this.trackside = false;
      this.allrace = false;
      this.nova = false;
      this.luckyHorse = false;
      this.cricketSuperOver = false;
      this.racingRoulette = false;
      this.keno = false;
      this.luckyloot = true;
    }
  }


  categories = [

    {
      filter: 1,
      sport: 'HR',
      image: '../../../assets/images/pc.png',
      inplay: false,
      country: 'VR',
      name: 'Next 10',
      num: 4,
      active: true
    },
    {
      filter: 2,
      sport: 'HR',
      image: '../../../assets/images/uk.png',
      inplay: false,
      country: 'VR',
      name: 'All Races',
      num: 1,
      active: false
    },
    {
      filter: 2,
      sport: 'VR',
      image: '../../../assets/images/cricket_superOver_logo.png',
      inplay: false,
      country: 'VR',
      name: 'e-Cricket Super Over',
      num: 7,
      active: true
    },
    {
      filter: 1,
      sport: 'VR',
      image: '../../../assets/images/trackside.png',
      inplay: false,
      country: 'AU',
      name: 'Track Side',
      num: 2,
      active: false
    },
    {
      filter: 1,
      code: 'HR',
      image: '../../../assets/images/kiron.png',
      inplay: false,
      country: 'KR2',
      name: 'Lucky Horse',
      num: 6,
      active: false
    },
    {
      filter: 1,
      code: 'HR',
      image: '../../../assets/images/kiron.png',
      inplay: false,
      country: 'KR',
      name: 'Classic',
      num: 3,
      active: false
    },
    {
      filter: 1,
      code: 'HR',
      image: '../../../assets/images/kiron.png',
      inplay: false,
      country: 'KR2',
      name: 'Nova',
      num: 5,
      active: false
    },
    {
      filter: 1,
      code: 'VR',
      image: '../../../assets/images/racing-roulette.png',
      inplay: false,
      country: 'KR2',
      name: 'Racing Roulette',
      num: 8,
      active: true
    },
    {
      filter: 1,
      code: 'VR',
      image: '../../../assets/images/keno.png',
      inplay: false,
      country: 'KR2',
      name: 'Keno',
      num: 9,
      active: false
    },
    {
      filter: 1,
      code: 'VR',
      image: '../../../assets/images/luckyloot.png',
      inplay: false,
      country: 'KR2',
      name: 'Lucky Loot',
      num: 10,
      active: false
    },
  ];

  get filteredCategories() {
    if (this.isRacing) {
      return this.categories_arry.filter(item => item.name === this.VRCategories[0] || item.name === this.VRCategories[1] || item.name === this.VRCategories[3] || item.name === this.VRCategories[4] || item.name === this.VRCategories[5] || item.name === this.VRCategories[6]);
    } else if (this.isSports) {
      return this.categories_arry.filter(item => item.name === this.VRCategories[2]);
    } else if (this.isGames) {
      return this.categories_arry.filter(item => item.name === this.VRCategories[7] || item.name === this.VRCategories[8] || item.name === this.VRCategories[9]);
    }
    return this.categories_arry;
  }

  updateCategoryFlags(url: string) {
    this.isRacing = url.includes('/home/vartual/racing');
    this.isSports = url.includes('/home/vartual/sports');
    this.isGames = url.includes('/home/vartual/games');
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }



}
